import { render, staticRenderFns } from "./IssueProductsReport.vue?vue&type=template&id=1d2b288e"
import script from "./IssueProductsReport.vue?vue&type=script&lang=js"
export * from "./IssueProductsReport.vue?vue&type=script&lang=js"
import style0 from "./IssueProductsReport.vue?vue&type=style&index=0&id=1d2b288e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports